export function initAutoBanners() {
  $('body').on('click', '.auto_banner .banner_button, .auto_banner .auto_banner_close', (e) => {
    const $banner = $(e.target).closest('.auto_banner');
    const $allContainer = $banner.closest('.all_banners_container');

    $.cookie($banner.data('banner-cookie'), 1, { expires: 1, path: '/' });
    $banner.hide();
    $allContainer.hide();
  });

  if (zr.page.model.isZDS) {
    const $seoAutoBanners = $('.auto_banners_seo');
    if (!$seoAutoBanners.children().length) {
      $seoAutoBanners.hide();
    }

    // for all other autobanners, move it into our container for proper positioning/stacking
    $(document).on('ModalLoaded', () => {
      const $autoBannersContainer = $('.get-auto-banners');
      const $allBannersContainer = $('.all_banners_container');

      if (!$autoBannersContainer.children().length) {
        $allBannersContainer.hide();
        return;
      }

      // hide for a second to fix async css jankiness
      $autoBannersContainer.css('opacity', 0);
      setTimeout(() => $autoBannersContainer.css('opacity', 1), 500);
      $autoBannersContainer.detach().prependTo($allBannersContainer);
    });
  }
}
